import { Collapse, TypedFormFieldComponents } from '@fl/cmsch-fe-library';
import React, { FC, Fragment, memo, ReactNode } from 'react';
import { Opt } from 'ts-opt';
import { Accordion } from 'api/gen/Accordion';
import { CriteriaDefinition } from 'api/gen/CriteriaDefinition';
import { Ant } from 'common/ant';
import { AccordionCollapse, AccordionCollapseProps } from './accordion-collapse';
import { MatingBullsFilterFormValues, MatingCowsFilterFormValues } from '../../types';
interface Props<T> {
  /** Accordion definitions rendered in the collapse. */
  criteriaAccordions: Array<Accordion>;
  /** Criteria definitions bound to each accordion. */
  criteriaDefinitions: Array<CriteriaDefinition>;
  /** Extra nodes shown in the first accordion. */
  extraFirstAccordionNodes: ReactNode;
  /** Typed form field components for the active form. */
  Fields: TypedFormFieldComponents<T>;
  /** Resets the current accordion values. */
  resetCowsAccordionValues(accordionId: number): void;
  /** Resets one criteria field from the accordion. */
  resetCriteriaValue(criteriaName: Opt<string>): void;
}
const span0 = 0;
const span4 = 4;
const span34 = 34;
/** Default accordion position rendered open in mating criteria groups. */
export const firstAccordionPosition = 1;
const CriteriasInCollapseBase: FC<Props<MatingCowsFilterFormValues | MatingBullsFilterFormValues>> = props => {
  const {
    criteriaAccordions,
    criteriaDefinitions,
    extraFirstAccordionNodes,
    resetCowsAccordionValues,
    resetCriteriaValue,
    Fields
  } = props;
  const CriteriaFields = Fields.genSection<'criterias', AccordionCollapseProps>();
  return <Fragment>
            {criteriaAccordions.map(accordion => <Collapse id={accordion.id} title={accordion.name} key={accordion.id} isActiveByDefault={accordion.position === firstAccordionPosition} resetValues={resetCowsAccordionValues} divider noBottomMargin>
                    {accordion.position === firstAccordionPosition && extraFirstAccordionNodes}
                    <Ant.Row gutter={[{
        xs: span0,
        xl: span34
      }, span4]} id={accordion.id.toString()} className="ml-0 mr-0">
                        <CriteriaFields name="criterias" Component={AccordionCollapse} props={{
          resetCriteriaValue,
          criteriaDefinitions,
          accordion
        }} />
                    </Ant.Row>
                </Collapse>)}
        </Fragment>;
};

/**
 * Memoized accordion tree for mating criteria sections.
 *
 * @param props Accordion data, form fields, and reset handlers.
 * @returns The criteria collapse tree.
 */
export const CriteriasInCollapse = memo(CriteriasInCollapseBase);